import React from 'react';

import styled from 'styled-components';

const StyledLink = styled.a`
  overflow: hidden;
  max-width: 205px;
  word-break: break-word;
  display: inline-block;
  font-size: 12px;
  vertical-align: middle;
  color: var(--dark-blue);
  text-wrap: auto;
  word-break: break-all;
`;

type Props = { website: string; dataTestId?: string };

const CMASummaryTableDataWebsite = ({ website, dataTestId }: Props) => {
  return (
    <StyledLink href={website} target="_blank" rel="noreferrer" title={website} data-test-id={dataTestId}>
      {website}
    </StyledLink>
  );
};

export default CMASummaryTableDataWebsite;
